/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AccountingConfigurationDto = {
    therapistId: number;
    providerType?: AccountingConfigurationDto.providerType | null;
    isConnected: boolean;
    connectedAt?: string | null;
    externalAccountId?: string | null;
    externalAccountName?: string | null;
    autoCreateInvoices: boolean;
    autoSendInvoices: boolean;
    autoBookPaymentFees: boolean;
    paymentFeeAccountNumber?: string | null;
    settings: Record<string, any>;
};
export namespace AccountingConfigurationDto {
    export enum providerType {
        LEXOFFICE = 'lexoffice',
        SEVDESK = 'sevdesk',
        TEBUTO = 'tebuto',
    }
}

